"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusCircle = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c3aa63ec8{max-width:100%;position:relative;font-size:0}.c68e55e06{position:absolute;margin:auto;top:0;bottom:0;left:0;right:0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding:0 .4375rem;height:1.125rem;text-align:center;font-size:1rem;font-weight:400;line-height:1.125rem;color:var(--color-flomni-blue-70)}.cf452b4ae{position:absolute}.cef7ff490{display:block;fill:transparent;stroke-linecap:round;stroke-width:.3125rem;opacity:.3;stroke:#e2e2e2}.c4c3260d8{display:block}.ceea775d5{stroke:var(--color-flomni-blue-70);display:block;fill:transparent;stroke-linecap:round;stroke-dasharray:283;stroke-width:.3125rem;-webkit-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);transition:stroke-dashoffset var(--animation-timing-def) ease}.c03be3ac0 .c68e55e06{color:var(--color-flomni-blue-70)}.c03be3ac0 .ceea775d5{stroke:var(--color-flomni-blue-70)}.c4c140b97 .c68e55e06{color:var(--color-flomni-green-70)}.c4c140b97 .ceea775d5{stroke:var(--color-flomni-green-70)}.cbcc3b968 .c68e55e06{color:var(--color-flomni-rose-70)}.cbcc3b968 .ceea775d5{stroke:var(--color-flomni-rose-70)}.c41488182 .c68e55e06{color:var(--color-flomni-gray-40)}.c41488182 .ceea775d5{stroke:var(--color-flomni-gray-40)}");
var styles = {
  root: 'c3aa63ec8',
  percents: 'c68e55e06',
  bg: 'cf452b4ae',
  rail: 'cef7ff490',
  spinner: 'c4c3260d8',
  circle: 'ceea775d5',
  '--view-usual': 'c03be3ac0',
  '--view-success': 'c4c140b97',
  '--view-warning': 'cbcc3b968',
  '--view-light': 'c41488182'
};

var StatusCircle = function StatusCircle(props) {
  var classes = props.classes,
      percents = props.percents,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var result = (0, _react.useMemo)(function () {
    var nValue = percents > 100 ? 100 : percents < 0 ? 0 : percents;
    var value = 100 - nValue;
    var nMin = 0;
    var nMax = 283;
    var min = 0;
    var max = 100;
    return (value - min) * (nMax - nMin) / (max - min) + nMin;
  }, [percents]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: cn.bg,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: cn.rail,
    cx: "50",
    cy: "50",
    r: "45"
  })), /*#__PURE__*/_react.default.createElement("svg", {
    className: cn.spinner,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: cn.circle,
    strokeDashoffset: result,
    cx: "50",
    cy: "50",
    r: "45"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.percents
  }, percents, "%"));
};

exports.StatusCircle = StatusCircle;
var view = ['usual', 'warning', 'success', 'light'];
StatusCircle.modes = {
  view: view
};
StatusCircle.propTypes = {
  /* styling modificators */
  percents: _propTypes.number.isRequired,
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
StatusCircle.defaultProps = {
  view: 'usual',
  classes: {}
};